import styled from "styled-components";
import React from "react";
import RelateAnswerLetter from "./RelateAnswerLetter";

type RelAnswerContainProps = {
  letters: string[];
  activeLetter: string | null;
  onActivateLetter?: (letter: string) => void;
};

const RelAnswerContain = ({
  letters,
  activeLetter,
  onActivateLetter,
}: RelAnswerContainProps) => {
  return (
    <>
      {letters.length > 0 && (
        <DivContainLetters>
          {letters.map((letter: string) => (
            <RelateAnswerLetter
              letter={letter}
              activeShareLetter={activeLetter}
              onActivate={() => onActivateLetter && onActivateLetter(letter)}
            />
          ))}
        </DivContainLetters>
      )}
    </>
  );
};

const DivContainLetters = styled.div`
  display: flex;
  margin-top: 1rem;
  gap: 2rem;
`;

export default RelAnswerContain;
